import {webDbAdapter} from "@/IndexDB.js"

	import queryString from 'query-string';
    const preUrl = process.realm.REALM_NODE_ENV === 'production' ? '/web/empower' : '/source/assets';
    let bgUrl = `${preUrl}/images/Fancy_bg1.webp`;
    let username;
	export const setEmpowerBg = async () =>
	{
	    if (top.location.href.indexOf('web/desktop') < 0) return;
        handleUsername();
        await handleDbBackground();
	    const dom = document.getElementById('EmpowerBg') || window.top.document?.getElementById('EmpowerBg');
	    dom.style.backgroundImage = `url(${bgUrl})`;
	}
    const handleUsername = () =>
    {
        const queryParams = queryString.parse(location.search)
        const oauthToken = queryParams?.jwtToken || localStorage.getItem('oauth-token');
        if (!oauthToken) return;
        const base64Data = oauthToken.split('.');
	    const userData = JSON.parse(decodeURIComponent(escape(window.top.atob(base64Data[1].replace(/-/g, '+').replace(/_/g, '/')))));
        username = userData.username;
    }
    const handleDbBackground = async () =>
    {
        if (!webDbAdapter || (username && webDbAdapter.db.username !== username))
        {
            webDbAdapter.renew()
        }
        try
	    {
            const queryCollection = sessionStorage.getItem(`${username || 'onecloud'}_codigger_curCollection`) || 'Collection1';
            let backgroundImages = [];
            const maps = await webDbAdapter.db.dbInstance['sk_desktop_interface'].where('runningType').equals('active').and(item => item.collection === queryCollection).each(item => backgroundImages.push(item.background));
            if (backgroundImages.length > 0)
            {
                const activeBg = backgroundImages[0];
                bgUrl = /(http(s)?:\/\/)/i.test(activeBg) ? activeBg : `${preUrl}/images/${activeBg}.webp`;
            }
	    }
	    catch(error)
	    {
	        console.error(error)
	    }
    }

